<div *transloco="let t; prefix: 'property-listing.ownership'" [formGroup]="ownershipFormGroup" class="flex-1">
  <div class="flex flex-col rfs:gap-12">
    <div class="flex flex-col gap-6">
      <h2 class="h2 text-black">{{ 'property-listing.tabs.ownership' | transloco }}</h2>
    </div>

    <div class="flex flex-col">
      <h3 class="h3 text-black mb-6">{{ t('subheaders.propertyUse') }}</h3>

      <fieldset class="flex flex-col gap-2 group/input max-w-[400px] mb-6">
        <label class="font-semibold flex items-center gap-2 text-gray-950 group-disabled:text-gray-300">
          {{ t('labels.kaek') }}
        </label>
        <input #maskedKaekInput [formControl]="maskedKaekFormControl" [validation]="true"
               class="bg-white text-gray-500 rounded-full border border-gray-300 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none"
               mask="00 000 00 00 000" placeholder="XX XXX XX XX XXX"
               type="text">
        <section>
          <span class="text-sm text-gray-700 disabled:text-gray-300">{{t('infoText.kaek')}}&nbsp;</span>
          <a href="https://www.ktimatologio.gr/" target="_blank" class="text-primary-700 text-sm font-normal font-semibold underline">{{t('infoText.kaek-national-registry')}}</a>
          <span class="text-sm text-gray-700 disabled:text-gray-300">&nbsp;{{t('infoText.kaek-last-part')}} </span>
        </section>
      </fieldset>

      <div class="font-semibold flex items-center gap-2 text-gray-950 group-disabled:text-gray-300 mb-2">
        {{ t('labels.propertyUsageCategory') }}
      </div>
      <div class="flex flex-row flex-wrap gap-4 mb-6">
        <label
          class="visual-checkbox flex flex-col"
          for="usageCommercial">
          <input
            (click)="ownershipFormGroup.controls.usageCategory.setValue(ownershipFormGroup.controls.usageCategory.value === propertyUsageCategory.Commercial ? null : propertyUsageCategory.Commercial)"
            [checked]="ownershipFormGroup.controls.usageCategory.value === propertyUsageCategory.Commercial"
            class="opacity-0 absolute h-0 w-0"
            id="usageCommercial"
            name="checkbox-selector-usageCommercial"
            type="checkbox">
          <span class="">{{
              'shared.enum.propertyUsageCategory.' +
              propertyUsageCategory.Commercial.toString() | transloco
            }}</span>
        </label>

        <label
          class="visual-checkbox flex flex-col"
          for="usageResidential">
          <input
            (click)="ownershipFormGroup.controls.usageCategory.setValue(ownershipFormGroup.controls.usageCategory.value === propertyUsageCategory.Residential ? null : propertyUsageCategory.Residential)"
            [checked]="ownershipFormGroup.controls.usageCategory.value === propertyUsageCategory.Residential"
            class="opacity-0 absolute h-0 w-0"
            id="usageResidential"
            name="checkbox-selector-usageCommercial"
            type="checkbox">
          <span class="">{{
              'shared.enum.propertyUsageCategory.' +
              propertyUsageCategory.Residential.toString() | transloco
            }}</span>
        </label>

        <label
          class="visual-checkbox flex flex-col"
          for="usageIndustrial">
          <input
            (click)="ownershipFormGroup.controls.usageCategory.setValue(ownershipFormGroup.controls.usageCategory.value === propertyUsageCategory.Industrial ? null : propertyUsageCategory.Industrial)"
            [checked]="ownershipFormGroup.controls.usageCategory.value === propertyUsageCategory.Industrial"
            class="opacity-0 absolute h-0 w-0"
            id="usageIndustrial"
            name="checkbox-selector-usageCommercial"
            type="checkbox">
          <span class="">{{
              'shared.enum.propertyUsageCategory.' +
              propertyUsageCategory.Industrial.toString() | transloco
            }}</span>
        </label>

        <label
          class="visual-checkbox flex flex-col"
          for="usageOther">
          <input
            (click)="ownershipFormGroup.controls.usageCategory.setValue(ownershipFormGroup.controls.usageCategory.value === propertyUsageCategory.Other ? null : propertyUsageCategory.Other)"
            [checked]="ownershipFormGroup.controls.usageCategory.value === propertyUsageCategory.Other"
            class="opacity-0 absolute h-0 w-0"
            id="usageOther"
            name="checkbox-selector-usageCommercial"
            type="checkbox">
          <span class="">{{
              'shared.enum.propertyUsageCategory.' +
              propertyUsageCategory.Other.toString() | transloco
            }}</span>
        </label>
      </div>
    </div>
    <div class="flex flex-col">
      <div class="mb-6">
        <h3 class="h3 text-black mb-6">{{ t('subheaders.ownership') }}</h3>
        <div class="font-semibold flex items-center gap-2 text-gray-950 group-disabled:text-gray-300 mb-4">
          {{ t('labels.ownershipType') }}
          <i class="icon-info-circle text-xl text-gray-900"></i>
        </div>
        <div class="flex flex-row items-center gap-4">
          <div class="flex-1 border border-gray-300 rounded-lg p-4">
            <label class="radio-selector secondary" for="ownershipFull" role="button">
              <input
                (click)="ownershipFormGroup.controls.ownershipType.setValue(ownershipType.Full)"
                [checked]="ownershipFormGroup.controls.ownershipType.value === ownershipType.Full"
                class="hidden"
                id="ownershipFull"
                name="ownershipType"
                type="radio">
              <div class="radio-selector-content">
              <span class="radio-selector-text font-semibold">
                {{
                  'shared.enum.ownershipType.' +
                  ownershipType.Full.toString() | transloco
                }}
              </span>
              </div>
            </label>
          </div>
          <div class="flex-1 border border-gray-300 rounded-lg p-4">
            <label class="radio-selector secondary" for="ownershipBare" role="button">
              <input
                (click)="ownershipFormGroup.controls.ownershipType.setValue(ownershipType.Bare)"
                [checked]="ownershipFormGroup.controls.ownershipType.value === ownershipType.Bare"
                class="hidden"
                id="ownershipBare"
                name="ownershipType"
                type="radio">
              <div class="radio-selector-content">
              <span class="radio-selector-text font-semibold">
                {{
                  'shared.enum.ownershipType.' +
                  ownershipType.Bare.toString() | transloco
                }}
              </span>
              </div>
            </label>
          </div>
        </div>
      </div>

      <form [formGroup]="ownershipFormGroup" class="mb-6" id="property-wizard">
        <fieldset class="flex flex-col gap-8 group/input">
          <label class="font-semibold flex gap-2 items-center text-gray-950 group-disabled:text-gray-300">
            {{ t('labels.ownershipPercentage') }}
          </label>
          <div class="flex flex-col lg:flex-row gap-4 items-center justify-center">
            <div class="min-w-[300px] flex-1">
              <label for="ownershipPercentageRange"></label>
              <input #ownershipPercentageRangeInput
                (input)="ownershipFormGroup.controls.ownershipPercentage.setValue(ownershipPercentageRangeInput.value)"
                [value]="ownershipFormGroup.controls.ownershipPercentage.value ?? 1" id="ownershipPercentageRange"
                [disabled]="ownershipFormGroup.controls.ownershipType.value === ownershipType.Full"
                max="100" min="1" step="1"
                type="range">
            </div>
            <input #ownershipPercentageInput
              (input)="ownershipFormGroup.controls.ownershipPercentage.setValue(ownershipPercentageInput.value ? ownershipPercentageInput.value : null)"
              class="bg-white text-gray-500 rounded-full border border-gray-300 py-3 px-4 group-focus-within/input:border-[1.5px] group-focus-within/input:text-gray-900 group-focus-within/input:border-primary-500 transition-colors duration-300 outline-none"
              formControlName="ownershipPercentage" max="100"
              min="1"
              [disabled]="isOwnershipPercentageDisabled()"
              oninput="if(this.value < 1) { this.value = null; } else if (this.value > 100) { this.value = 100; }"
              placeholder="1"
              type="number">
          </div>
        </fieldset>
      </form>

      <div class="font-semibold flex items-center gap-2 text-gray-950 group-disabled:text-gray-300 mb-3">
        {{ t('labels.availability') }}
      </div>

      <div class="flex flex-row items-center gap-4">
        <div class="flex-1 border border-gray-300 rounded-lg p-4">
          <label class="radio-selector secondary" for="availabilityRented" role="button">
            <input
              (click)="ownershipFormGroup.controls.availability.setValue(
                ownershipFormGroup.controls.availability.value === propertyAvailability.Rented ? null : propertyAvailability.Rented)"
              [checked]="ownershipFormGroup.controls.availability.value === propertyAvailability.Rented"
              class="hidden"
              id="availabilityRented"
              name="availability"
              type="radio">
            <div class="radio-selector-content">
              <span class="radio-selector-text font-semibold">
                {{
                  'shared.enum.availability.' +
                  propertyAvailability.Rented.toString() | transloco
                }}
              </span>
            </div>
          </label>
        </div>
        <div class="flex-1 border border-gray-300 rounded-lg p-4">
          <label class="radio-selector secondary" for="availabilityUsedByOwner" role="button">
            <input
              (click)="ownershipFormGroup.controls.availability.setValue(
                ownershipFormGroup.controls.availability.value === propertyAvailability.UsedByOwner ? null : propertyAvailability.UsedByOwner)"
              [checked]="ownershipFormGroup.controls.availability.value === propertyAvailability.UsedByOwner"
              class="hidden"
              id="availabilityUsedByOwner"
              name="availability"
              type="radio">
            <div class="radio-selector-content">
              <span class="radio-selector-text font-semibold">
                {{
                  'shared.enum.availability.' +
                  propertyAvailability.UsedByOwner.toString() | transloco
                }}
              </span>
            </div>
          </label>
        </div>
        <div class="flex-1 border border-gray-300 rounded-lg p-4">
          <label class="radio-selector secondary" for="availabilityVacant" role="button">
            <input
              (click)="ownershipFormGroup.controls.availability.setValue(
                ownershipFormGroup.controls.availability.value === propertyAvailability.Vacant ? null : propertyAvailability.Vacant)"
              [checked]="ownershipFormGroup.controls.availability.value === propertyAvailability.Vacant"
              class="hidden"
              id="availabilityVacant"
              name="availability"
              type="radio">
            <div class="radio-selector-content">
              <span class="radio-selector-text font-semibold">
                {{
                  'shared.enum.availability.' +
                  propertyAvailability.Vacant.toString() | transloco
                }}
              </span>
            </div>
          </label>
        </div>
      </div>
    </div>

  </div>
</div>
